/**
 * @enum ACCOUNT_PROFILE_HIERARCHY_ITEMS_SORT
 * @type {{CREATED_AT: string, START_DATE: string}}
 */
import { isShutterbug } from '../../../../util/account';

export const ACCOUNT_PROFILE_HIERARCHY_ITEMS_SORT = {
  CREATED_AT: 'CREATED_AT',
  START_DATE: 'START_DATE',
};

/**
 * Returns the name to use in account profiles.
 *
 * @param {Object} accountProfile The AccountProfile.
 * @returns {string}
 */
export const getAccountProfileName = accountProfile => {
  if (!accountProfile) {
    return '';
  }

  const username = accountProfile.username ? `@${accountProfile.username}` : '';

  if (isShutterbug(accountProfile)) {
    return accountProfile?.name || username || '';
  }

  return accountProfile?.organization_name || username || '';
};

/**
 * Returns the username to use in account profiles.
 *
 * @param {Object} accountProfile The AccountProfile.
 * @returns {string}
 */
export const getAccountProfileUsername = accountProfile => {
  if (!accountProfile) {
    return '';
  }

  return accountProfile.username ? `@${accountProfile.username}` : '';
};
